import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from 'components/private-route';
import Container from './components/container';

const Home = lazy(() => import('./pages/admin/home'));
const TherapistManagement = lazy(() => import('./pages/admin/therapist-management'));
const ServiceManagement = lazy(() => import('./pages/admin/service-management'));
const BookingManagement = lazy(() => import('./pages/admin/booking-management'));
// const PaymentManagement = lazy(() => import('./pages/admin/payment-management'));
const ContactSetting = lazy(() => import('./pages/admin/system-setting/contact-setting'));
const PricingSetting = lazy(() => import('./pages/admin/system-setting/pricing-setting'));
const VoucherSetting = lazy(() => import('./pages/admin/system-setting/voucher-setting'));
const GeneralInformation = lazy(() => import('./pages/admin/general-management'));
const AccountProfile = lazy(() => import('./pages/admin/account-profile'));
const PayoutProcess = lazy(() => import('./pages/admin/transaction/payout-process'));
const SettlementProcess = lazy(() => import('./pages/admin/transaction/settlement-process'));
const FinancialOverview = lazy(() => import('./pages/admin/financial-overview'));
const CustomerPlatformInfo = lazy(() => import('./pages/admin/system-setting/customer-platform-info'));
const PlatformRegulations = lazy(() => import('./pages/admin/system-setting/platform-regulations'));
// const NotFound = lazy(() => import("./pages/not-found"));

function Routing() {
    return (
        <Routes>
            <Route path="/admin" element={<Container />}>
                <Route path="home" element={<PrivateRoute element={<Home />} auth="admin" />} />
                <Route path="therapist-management" element={<PrivateRoute element={<TherapistManagement />} auth="admin" />} />
                <Route path="service-management" element={<PrivateRoute element={<ServiceManagement />} auth="admin" />} />
                <Route path="booking-management/:bookingCode?" element={<PrivateRoute element={<BookingManagement />} auth="admin" />} />
                {/* <Route path="payment-management" element={<PrivateRoute element={<PaymentManagement />} auth="admin" />} /> */}
                <Route path="system-setting.voucher-setting" element={<PrivateRoute element={<VoucherSetting />} auth="admin" />} />
                <Route path="system-setting.pricing-setting" element={<PrivateRoute element={<PricingSetting />} auth="admin" />} />
                <Route path="system-setting.contact-setting" element={<PrivateRoute element={<ContactSetting />} auth="admin" />} />
                <Route path="general-management" element={<PrivateRoute element={<GeneralInformation />} auth="admin" />} />
                <Route path="system-setting.customer-platform-info" element={<PrivateRoute element={<CustomerPlatformInfo />} auth="admin" />} />
                <Route path="system-setting.platform-regulations" element={<PrivateRoute element={<PlatformRegulations />} auth="admin" />} />
                <Route path="account-profile" element={<PrivateRoute element={<AccountProfile />} auth="admin" />} />
                <Route path="payout-process" element={<PrivateRoute element={<PayoutProcess />} auth="admin" />} />
                <Route path="settlement-process" element={<PrivateRoute element={<SettlementProcess />} auth="admin" />} />
                <Route path="financial-overview" element={<PrivateRoute element={<FinancialOverview />} auth="admin" />} />
            </Route>
        </Routes>
    );
}

export default Routing;
